import { Component, Input } from '@angular/core';
import { CMSAbstractGridEntry } from '../../core/abstract-grid.model';

@Component({
  selector: 'cms-abstract-grid-card',
  templateUrl: './cms-abstract-grid-card.component.html',
  styleUrl: './cms-abstract-grid-card.component.scss',
  standalone: false,
})
export class CmsAbstractGridCardComponent {
  @Input() CMSAbstractGridEntry!: CMSAbstractGridEntry;
  @Input() backgroundColor?: string;

  defaultBackground: string = '#e5e5e5';
}
